import { render, staticRenderFns } from "./LocationField.vue?vue&type=template&id=c04b4162"
import script from "./LocationField.vue?vue&type=script&lang=js"
export * from "./LocationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports